import HighlightsBookShelf from './HighlightsBookShelf'

export default HighlightsBookShelf
